import { useState, useEffect } from 'react'
import { VITE_API_BASE as API } from '../config/apiConfig'

export default function Recommend() {
  const [tab, setTab] = useState('rules')
  const [records, setRecords] = useState([])
  const [rewards, setRewards] = useState([])
  const [showRule, setShowRule] = useState(false)
  const [ruleForm, setRuleForm] = useState({ type: 'coupon', rewardValue: 50, threshold: 1 })

  useEffect(() => { loadData() }, [])

  const loadData = async () => {
    try {
      const [r1, r2] = await Promise.all([
        fetch(`${API}/marketing/recommend-records`),
        fetch(`${API}/marketing/recommend-rewards`)
      ])
      const [d1, d2] = await Promise.all([r1.json(), r2.json()])
      if (d1.success) setRecords(d1.data || [])
      if (d2.success) setRewards(d2.data || [])
    } catch (e) { console.error(e) }
  }

  const createReward = async () => {
    try {
      const res = await fetch(`${API}/marketing/recommend-rewards`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(ruleForm)
      })
      const data = await res.json()
      if (data.success) { alert('创建成功'); setShowRule(false); loadData() }
    } catch (e) { alert('创建失败') }
  }

  const stats = {
    totalRecommenders: new Set(records.map(r => r.recommenderId)).size,
    totalRecommended: records.length,
    successRewards: rewards.filter(r => r.status === 'given').length,
    totalAmount: rewards.filter(r => r.status === 'given').reduce((sum, r) => sum + (r.rewardValue || 0), 0)
  }

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🎁 推荐有礼</h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>推荐人</div><div style={{ fontSize: 28, color: '#1890ff' }}>{stats.totalRecommenders}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>被推荐</div><div style={{ fontSize: 28, color: '#722ed1' }}>{stats.totalRecommended}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>已发放奖励</div><div style={{ fontSize: 28, color: '#52c41a' }}>{stats.successRewards}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>奖励总额</div><div style={{ fontSize: 28, color: '#fa8c16' }}>¥{stats.totalAmount}</div></div>
      </div>

      <div style={{ background: '#fff', borderRadius: 8, padding: 16, marginBottom: 16 }}>
        <h3 style={{ fontSize: 14, marginBottom: 12 }}>📢 推荐规则</h3>
        <div style={{ color: '#666', fontSize: 13, lineHeight: 1.8 }}>
          <p>• 推荐1位新用户下单，奖励 <span style={{ color: '#f5222d', fontWeight: 600 }}>¥50</span> 优惠券</p>
          <p>• 推荐3位新用户下单，额外奖励 <span style={{ color: '#f5222d', fontWeight: 600 }}>¥100</span> 现金</p>
          <p>• 推荐5位新用户下单，额外奖励 <span style={{ color: '#f5222d', fontWeight: 600 }}>¥300</span> + 精美礼品</p>
          <p>• 奖励在订单完成后自动发放</p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button onClick={() => setTab('records')} style={{ padding: '8px 16px', border: 'none', background: tab === 'records' ? '#1890ff' : '#f5f5f5', color: tab === 'records' ? '#fff' : '#333', borderRadius: 6, cursor: 'pointer' }}>推荐记录</button>
        <button onClick={() => setTab('rewards')} style={{ padding: '8px 16px', border: 'none', background: tab === 'rewards' ? '#1890ff' : '#f5f5f5', color: tab === 'rewards' ? '#fff' : '#333', borderRadius: 6, cursor: 'pointer' }}>奖励记录</button>
        <button onClick={() => setShowRule(true)} style={{ marginLeft: 'auto', padding: '8px 16px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>+ 添加奖励规则</button>
      </div>

      {tab === 'records' && (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ background: '#fafafa' }}><th style={th}>推荐人</th><th style={th}>被推荐人</th><th style={th}>推荐产品</th><th style={th}>订单金额</th><th style={th}>奖励</th><th style={th}>时间</th></tr></thead>
            <tbody>
              {records.map(r => (
                <tr key={r.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{r.recommenderName || r.recommenderPhone}</td>
                  <td style={td}>{r.recommendedName || r.recommendedPhone}</td>
                  <td style={td}>{r.productName}</td>
                  <td style={{ ...td, color: '#f5222d' }}>¥{r.orderAmount}</td>
                  <td style={{ ...td, color: '#52c41a' }}>¥{r.reward || 0}</td>
                  <td style={td}>{r.createdAt ? new Date(r.createdAt).toLocaleDateString() : '-'}</td>
                </tr>
              ))}
              {records.length === 0 && <tr><td colSpan={6} style={{ ...td, textAlign: 'center', color: '#999' }}>暂无推荐记录</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
